import { queryOptions } from '@tanstack/react-query'

import { listReports } from './requests'

import type { ListReportsParams, ListReportsResponse } from './types'
import type { UseQueryOptions } from '@tanstack/react-query'

const QUERY_KEY_ROOT = 'yieldbirdWrapperAgent'

export const reportsQueryKey = [QUERY_KEY_ROOT, 'reports'] as const

type ReportsQueryKey = readonly [...typeof reportsQueryKey, ListReportsParams]

export const reportsQueryOptions = (
  params: ListReportsParams,
): UseQueryOptions<ListReportsResponse, Error, ListReportsResponse, ReportsQueryKey> =>
  queryOptions({
    queryFn: () => listReports(params),
    queryKey: [...reportsQueryKey, params] as const,
    refetchOnWindowFocus: false,
  })
